module.exports = __webpack_public_path__ + "img/ds03.png";